'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _messages = require('common/messages');

var _query = require('utilities/query');

var _userIngredients = require('./user-ingredients.html');

var _userIngredients2 = _interopRequireDefault(_userIngredients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _userIngredients2.default,
  bindings: {
    flex: '@',
    layout: '@',
    ingredients: '<',
    query: '<'
  },
  controller: function () {
    function UserIngredientsComponent($mdDialog, $scope, $state, ToastService, UserIngredientsService) {
      'ngInject';

      _classCallCheck(this, UserIngredientsComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        ToastService: ToastService,
        UserIngredientsService: UserIngredientsService
      });
    }

    _createClass(UserIngredientsComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.columns = [{
          FieldName: 'UserIngredientName',
          DisplayName: 'Ingredient Name'
        }, {
          FieldName: 'ProductCount',
          DisplayName: 'Product Count'
        }];

        this.selectedIngredients = [];
      }
    }, {
      key: 'onSearchTextChanged',
      value: function onSearchTextChanged(_ref) {
        var searchText = _ref.searchText;

        this.selectedIngredients = [];
        this.searchText = searchText;
        this.query = _extends({}, this.query, {
          filter: (0, _odataFilterBuilder2.default)().contains('UserIngredientName', searchText)
        });

        this.refreshResults();
      }
    }, {
      key: 'onQueryChanged',
      value: function onQueryChanged(_ref2) {
        var query = _ref2.query;

        this.selectedIngredients = [];
        this.query = query;
        this.refreshResults();
      }
    }, {
      key: 'refreshResults',
      value: function refreshResults() {
        var _this = this;

        this.promise = this.UserIngredientsService.search(this.query);
        this.promise.then(function (r) {
          _this.ingredients = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });
      }
    }, {
      key: 'canDeleteIngredients',
      value: function canDeleteIngredients(ingredients) {
        if (!(ingredients && ingredients.length)) {
          return false;
        }

        return true; // !ingredients.some(x => x.ProductCount > 0);
      }
    }, {
      key: 'ingredientAdd',
      value: function ingredientAdd() {
        var _this2 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          ingredientChanged: function ingredientChanged($event) {
            return _this2.onIngredientAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-ingredient-form\n                dialog-title="Add New User Ingredient"\n                submit-title="Add User Ingredient"\n                ingredient-changed="ingredientChanged($event)">\n              </user-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onIngredientAdded',
      value: function onIngredientAdded(_ref3) {
        var _this3 = this;

        var ingredient = _ref3.ingredient;

        this.UserIngredientsService.add(ingredient).then(function () {
          _this3.$mdDialog.hide();
          _this3.refreshResults();
          _this3.ToastService.showSuccess(_messages.USER_INGREDIENT_ADDED);
        }).catch(function (error) {
          return _this3.ToastService.showError(error);
        });
      }
    }, {
      key: 'ingredientEdit',
      value: function ingredientEdit(ingredient) {
        var _this4 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          ingredientChanged: function ingredientChanged($event) {
            return _this4.onIngredientEdited($event);
          },
          ingredient: _angular2.default.copy(ingredient)
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-ingredient-form\n                ingredient="ingredient"\n                dialog-title="Edit User Ingredient"\n                submit-title="Save Changes"\n                ingredient-changed="ingredientChanged($event)">\n              </user-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'ingredientDelete',
      value: function ingredientDelete(ingredients) {
        var _this5 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent(_messages.USER_INGREDIENT_DELETE_CONFIRMATION).ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          var promises = [];
          for (var i = ingredients.length - 1; i >= 0; i -= 1) {
            promises.push(_this5.UserIngredientsService.delete(ingredients[i].UserIngredientId));
          }

          Promise.all(promises).then(function () {
            _this5.ToastService.showSuccess(_messages.USER_INGREDIENT_DELETED);
            _this5.selectedIngredients = [];
            _this5.refreshResults();
          }).catch(function (error) {
            if (error.statusText === 'Bad Request' && error.data && error.data.Message) {
              _this5.ToastService.showError(error, error.data.Message);
            } else {
              _this5.ToastService.showError(error);
            }
          });
        });
      }
    }, {
      key: 'onIngredientEdited',
      value: function onIngredientEdited(_ref4) {
        var _this6 = this;

        var ingredient = _ref4.ingredient;

        this.UserIngredientsService.update(ingredient).then(function () {
          _this6.$mdDialog.hide();
          _this6.selectedIngredients = [];
          _this6.refreshResults();
          _this6.ToastService.showSuccess(_messages.USER_INGREDIENT_EDITED);
        }).catch(function (error) {
          return _this6.ToastService.showError(error);
        });
      }
    }]);

    return UserIngredientsComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredients.component.js